export const Events = {
  NETWORK_REQUEST: "Network Request",
  NETWORK_ERROR: "Network Error",
  BUTTON_CLICK: "Button Clicked",
  SHORTCUT_USE: "Shortcut Used",
  FORGE_SETTINGS_CHANGE: "Forge Settings Changed",
  FORGE_CLICK: "Forge Clicked",
  FORGE_START: "Forge Start",
  FORGE_ERROR: "Forge Error",
  STYLE_CREATE: "Style Created",
  STYLE_CREATE_TRIGGER_ERROR: "Style Creation Cannot Start",
};
